import styled from "styled-components";

export const Container = styled.section`
  h2 {
    color: #2f4760;
    font-size: 26px;
    font-weight: 300;
  }
`;
